function sendFilterAjax(attributes, category){

	$('.tagged-posts').fadeOut();

	data = {
		action: 'filter_posts',
		afp_nonce: afp_vars.afp_nonce,
		taxonomy: attributes,
		category: category
	};

	$.ajax({
		type: 'post',
		dataType: 'json',
		url: afp_vars.afp_ajax_url,
		data: data,
		success: function( data, textStatus, XMLHttpRequest ) {
			$('.tagged-posts').html( data );
			$('.tagged-posts').fadeIn();
		},
		error: function( MLHttpRequest, textStatus, errorThrown ) {
			$('.tagged-posts').html( '<div class="text-center"><i class="search-fail-icon"></i><h2 class="center-block ">Nie znaleziono zastosowań</h2></div>' );
			$('.tagged-posts').fadeIn();
		}
	});
}

function getActiveTags() {
		var checkboxes = $('.tags-checkbox-list').find('[type=checkbox]:checked'),
			filterAttributes = [];

			checkboxes.each(function(idx, el){
				filterAttributes.push($(el).attr('value'));
			});

		return filterAttributes;
}

function getActiveCategory() {
	var category = $('#cat').find(':selected').val();

	return category;
}

jQuery(document).ready(function($) {
	$(document).on('change', '.tax-filter', function() {
		filterAttributes = getActiveTags();
		category = getActiveCategory();
		sendFilterAjax(filterAttributes, category);
	});
});
jQuery(window).load(function(){
	$(document).on('change', '#cat', function() {
		filterAttributes = getActiveTags();
		category = getActiveCategory();
		sendFilterAjax(filterAttributes, category);
	});
});
